import React from "react";
import "../styles/CustomButton.css";

const CustomButton = ({
  children,
  onClick,
  type = "button",
  disabled = false,
  variant = "primary",
  size = "medium",
  className = "",
  ...props
}) => {
  const buttonClasses =
    `custom-button custom-button--${variant} custom-button--${size} ${className}`.trim();

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={buttonClasses}
      {...props}
    >
      {children}
    </button>
  );
};

export default CustomButton;
